import React from 'react'
import { Nav } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from "react-i18next"

export default function SidebarClient({ isCollapsed, client, handleClientSelect }) {
	const { t } = useTranslation()
	const location = useLocation()

	const isActive = (path) => {
		return location.pathname.includes(path)
	}

  	return (		
		<div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`} id="sidebar">
			<Link to="/">
				<img 
					src={isCollapsed ? '/images/logotipo-reducido-movil.svg' : '/images/logotipo-sdplay-cabecera.svg'} 
					id="logo-menu" 
					alt='Logotipo SDPlay' 
				/>
			</Link>
			<Nav className="flex-column p-0">
				<Nav.Item>
					<Link 
						to={`/${t("url.client.client")}/${t("url.client.dashboard")}`}
						className={isActive(t("url.client.dashboard")) ? 'active' : ''}
					>
						<img src="/images/menus/dashboard.svg" alt={t('menus.general.mydashboard')}/> 
						{!isCollapsed && t('menus.general.mydashboard')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link 
						to={`/${t("url.client.client")}/${t("url.client.personaldata")}`} 
						onClick={() => handleClientSelect(client)}
						className={isActive(t("url.client.personaldata")) ? 'active' : ''}
					>
						<img src="/images/menus/user.svg" alt={t('menus.general.profile')}/> 
						{!isCollapsed && t('menus.general.profile')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link 
						to={`/${t("url.client.client")}/${t("url.client.members")}`}
						className={isActive(t("url.client.members")) ? 'active' : ''}
					>
						<img src="/images/menus/members.svg" alt={t('menus.general.members')}/> 
						{!isCollapsed && t('menus.general.members')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link 
						to={`/${t("url.client.client")}/${t("url.client.inscriptions")}`}
						className={isActive(t("url.client.inscriptions")) ? 'active' : ''}
					>
						<img src="/images/menus/calendar.svg" alt={t('menus.general.inscriptions')}/> 
						{!isCollapsed && t('menus.general.inscriptions')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link 
						to={`/${t("url.client.client")}/${t("url.client.reservations")}`}
						className={isActive(t("url.client.reservations")) ? 'active' : ''}
					>
						<img src="/images/menus/calendar.svg" alt={t('menus.general.reserve')}/> 
						{!isCollapsed && t('menus.general.reserve')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link 
						to={`/${t("url.client.client")}/${t("url.client.payments")}`}
						className={isActive(t("url.client.payments")) ? 'active' : ''}
					>
						<img src="/images/menus/payments.svg" alt={t('menus.general.payments')}/> 
						{!isCollapsed && t('menus.general.payments')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link 
						to={`/${t("url.client.client")}/${t("url.client.passes")}`}
						className={isActive(t("url.client.passes")) ? 'active' : ''}
					>
						<img src="/images/menus/pass.svg" alt={t('menus.general.passes')}/> 
						{!isCollapsed && t('menus.general.passes')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link 
						to={`/${t("url.client.client")}/${t("url.client.tickets")}`}
						className={isActive(t("url.client.tickets")) ? 'active' : ''}
					>
						<img src="/images/menus/ticketing.svg" alt={t('menus.general.tickets')}/> 
						{!isCollapsed && t('menus.general.tickets')}
					</Link>
				</Nav.Item>
				<Nav.Item className='disabled'>
					<Link to="/#" onClick={(e) => e.preventDefault()}>
						<img src="/images/menus/promociones.svg" alt={t('menus.general.promotions')}/> 
						{!isCollapsed && t('menus.general.promotions')}
					</Link>
				</Nav.Item>
			</Nav>
		</div>
	)
}